module.exports = __webpack_public_path__ + "img/EMT-OVCA_10X_TPCP.40a575ab.png";